module.exports = __webpack_public_path__ + "img/fengcai2.80cd7753.jpg";